export const ACCUMULATE = 'accumulate';
export const BUCKET_CREATED = 'bucket:created';
export const BUCKET_LIFECYCLESTAGE = 'bucket:lifecyclestage';
export const GROUP_TEAMS = 'groupteams';
export const ZERO_DIMENSIONAL_METRIC_FUNNEL = 'zerodimensionalmetricfunnel';
export const NEGATIVE_LOST = 'negativelost';